/**
 * Compose the CSS `transform` for a sortable spread thumbnail.
 *
 * dnd-kit gives us a base translate transform (its drag/sort animation). When
 * the drag is *armed* (long-press elapsed → `isDragging`) we add a slight
 * scale-up "lift" so the customer can see the thumbnail is now draggable.
 *
 * The base transform can be `undefined` (no movement yet — e.g. the instant the
 * 2s hold completes but the finger hasn't slid). Naively interpolating that
 * yields the invalid CSS string `"undefined scale(1.08)"`, which silently kills
 * the lift. This helper keeps the composition null-safe.
 */
export const SPREAD_DRAG_LIFT = 'scale(1.08)';

export function spreadDragTransform(
  baseTransform: string | undefined,
  isDragging: boolean,
): string | undefined {
  if (!isDragging) return baseTransform || undefined;
  return baseTransform ? `${baseTransform} ${SPREAD_DRAG_LIFT}` : SPREAD_DRAG_LIFT;
}
